// @flow
import * as React from "react";
import { withRouter } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import ErrorPage from "../../components/ErrorPage";
import commonPaths from "../../data/commonPaths";

type ErrorPagePortalProps = {
  history: {
    goBack: () => void
  }
};

const ErrorPagePortal = ({ history: { goBack } }: ErrorPagePortalProps) => (
  <PageLayout>
    <ErrorPage
      goBack={goBack}
      pathname={commonPaths.error404}
      route404={commonPaths.error404}
      isPortal
    />
  </PageLayout>
);

export default withRouter(ErrorPagePortal);
